import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Alert Fatigue',
  slug: 'alert-fatigue',
  definition: `Alert fatigue occurs when teams receive so many alerts that they start ignoring them. It is one of the most dangerous problems in operations — the alerts are there, but nobody acts on them because the signal is buried in noise.

The root causes are usually too-sensitive thresholds, no alert confirmation, missing deduplication, or monitoring things that do not need to be monitored. A single flaky endpoint can generate hundreds of alerts per week if there is no confirmation logic.

Alert fatigue has a compounding effect. As the team learns to ignore alerts, response times increase. Eventually, a real outage alert gets the same treatment as the noise, and the incident goes unnoticed for far longer than it should.`,
  whyItMatters: `Alert fatigue is one of the top causes of extended outages. Studies show that when alert volume exceeds a manageable level, teams take 30-50% longer to respond to real incidents.

It also contributes to burnout and on-call dissatisfaction. Engineers who are woken up at night for false alerts lose trust in the alerting system and eventually stop responding urgently.`,
  howUptrackHelps: `Uptrack's confirmation check system is specifically designed to prevent alert fatigue. When a check fails, Uptrack runs additional confirmation checks before triggering an alert. Only verified, persistent outages generate notifications.

This means you get far fewer alerts, and the ones you do get are almost always real problems that need attention. Your team learns to trust the alerts and responds quickly.`,
  relatedTerms: [
    { name: 'On-Call', href: '/glossary/on-call' },
    { name: 'Escalation Policy', href: '/glossary/escalation-policy' },
    { name: 'Incident Management', href: '/glossary/incident-management' },
    { name: 'MTTD', href: '/glossary/mttd' },
  ],
}

export const Route = createFileRoute('/_site/glossary/alert-fatigue')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
